exports.isInvalidApiTokenError = (error, { activeToken } = {}) => {

    if (error?.response?.status !== 401 || !activeToken) {
        return false;
    }

    const headers = error?.config?.headers;
    const authorization = typeof headers?.get === 'function'
        ? headers.get('Authorization')
        : headers?.Authorization || headers?.authorization;
    const rejectedToken = typeof authorization === 'string'
        ? authorization.match(/^Bearer\s+(.+)$/i)?.[1]
        : null;
    const message = String(error?.response?.data?.message || '').toLowerCase();

    return rejectedToken === activeToken
        && (message === 'invalid credentials' || message.startsWith('invalid token'));
};
